// extracted by mini-css-extract-plugin
module.exports = {"iconBack":"_3bOQzkkyOOlWq1yLyZdpXP","iconTrash":"_2UWPLUn6zNEKoKf3YY-zR2"};